module.exports = global["Player"] = require("-!/home/player/releases/player-master-7fd7534c3c36e62a7917005612ea26b32c9aabc7-33/node_modules/babel-loader/lib/index.js!/home/player/releases/player-master-7fd7534c3c36e62a7917005612ea26b32c9aabc7-33/node_modules/string-replace-webpack-plugin/loader.js?id=eb7ctl8x67d!./player.js");


//////////////////
// WEBPACK FOOTER
// ./src/player.js
// module id = RQgh
// module chunks = 0